import request from '@/plugins/request';
export function getDictItemByCodes(data) {
  return request({
    url: '/bms/sys/dict-item/list',
    method: 'get',
    params: data
  });
}
export function getDictItemByCodeVague(data) {
  return request({
    url: '/bms/sys/dict-item/vague-code/list',
    method: 'get',
    params: data
  });
}